import axios from 'axios';
const CONTROLLER_PATH = 'BillingItem';
class BillingItemService {
    //CREATE
    create(entity) {
        return axios.post(CONTROLLER_PATH, entity).then((response) => response.data);
    }

    getBillingItemLink(id) {
        return axios.get(CONTROLLER_PATH + '/GetBillingItemLink/'+id).then((response) => response.data);
    }

    checkStatus(id) {
        return axios.get(CONTROLLER_PATH + '/CheckStatus/'+id);
    }

    convertToAccount(id) {
        return axios.get(CONTROLLER_PATH + '/ConvertToAccount/'+id);
    }

    getMedediStatuses() {
        return axios.get(CONTROLLER_PATH + "/getMedediStatuses").then((response) => response.data);
    }
    getLocalStatuses() {
        return axios.get(CONTROLLER_PATH + "/getLocalStatuses").then((response) => response.data);
    }
    getMedediPlacesOfService() {
        return axios.get(CONTROLLER_PATH + "/getMedediPlacesOfService").then((response) => response.data);
    }

    //UPDATE
    update(entity) {
        return axios.put(CONTROLLER_PATH + '/' + entity.id, entity).then((response) => response.data);
    }

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + '/' + id).then(() => {});
    }
}

export default new BillingItemService();
